// extracted by mini-css-extract-plugin
export default {"controlButton":"Oz1ffs","hidden":"nhI_ow","title":"ZDJjun","link":"Jd96zq"};